import { render, staticRenderFns } from "./ViewDetails.vue?vue&type=template&id=1680435b&scoped=true"
import script from "./ViewDetails.vue?vue&type=script&lang=js"
export * from "./ViewDetails.vue?vue&type=script&lang=js"
import style0 from "./ViewDetails.vue?vue&type=style&index=0&id=1680435b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1680435b",
  null
  
)

export default component.exports